import React from 'react'
import map from 'lodash/map'
import classnames from 'classnames'

import './StepIndicator.scss'

interface StepIndicatorProps {
  readonly currentStep: number
  readonly maxSteps: number
  readonly stepName: string
}

const StepIndicator: React.FC<StepIndicatorProps> = props => {
  const { currentStep, stepName } = props

  const steps = Array.from(Array(props.maxSteps).keys())

  const bars = map(steps, (step) => {
    const isCurrentOrPastStep = step <= currentStep - 1
    return (
      <li
        key={step}
        className={classnames(
          'StepIndicator__bar',
          {'StepIndicator__bar-active': isCurrentOrPastStep})
        }
      />
    )
  })

  return (
    <div className="StepIndicator">
      <div className="StepIndicator__text">
        Step {currentStep}: {stepName}
      </div>
      <ul className="StepIndicator__bars">
        {bars}
      </ul>
    </div>
  )
}

export default StepIndicator
